import _ from 'lodash';

export const getCustomerProfilePasswordConfig = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-customer-profile.resetPasswordLabels`,
  );
};

export const getCustomerProfilePasswordSubmitLoading = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.customerResetPassword.isSubmitLoading`,
    false,
  );
};

export const getCustomerProfilePasswordValue = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.customerResetPassword.password`,
    '',
  );
};
